import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-20/task-01";

const task: Slide = {
  titleHtml:
    "A loudspeaker whose moving mass weighs 10 g and whose membrane has an<br>equivalent diameter of 10 cm is mounted in a planar baffle. What is its total mass,<br>including the radiation terms?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
